var chunkMapping = {
	"405": [
		20405
	],
	"479": [
		42932
	],
	"1097": [
		11097
	],
	"1415": [
		98832
	],
	"2388": [
		19421
	],
	"3065": [
		93065
	],
	"3278": [
		93278
	],
	"4198": [
		1403
	],
	"4523": [
		64523
	],
	"6170": [
		96170
	],
	"7287": [
		17182
	],
	"7481": [
		42514
	],
	"7512": [
		65387
	],
	"7531": [
		57531
	],
	"7627": [
		78414
	],
	"7747": [
		6940
	],
	"7882": [
		97882
	],
	"8850": [
		28850
	],
	"9091": [
		99091
	],
	"9819": [
		79819
	]
};
var idToExternalAndNameMapping = {
	"1403": [
		"default",
		"./forgotpassword",
		66571
	],
	"6940": [
		"default",
		"./mosaic-signin/mosaic-edit",
		66571
	],
	"11097": [
		"default",
		"./voucher",
		66571
	],
	"17182": [
		"default",
		"./signup/submitpayment",
		66571
	],
	"19421": [
		"default",
		"./signup/mosaic-edit",
		66571
	],
	"20405": [
		"default",
		"./partner",
		66571
	],
	"28850": [
		"default",
		"./remote-status",
		66571
	],
	"42514": [
		"default",
		"./mosaic-edit",
		66571
	],
	"42932": [
		"default",
		"./mosaic-signin",
		66571
	],
	"57531": [
		"default",
		"./tv/complete",
		66571
	],
	"64523": [
		"default",
		"./index",
		66571
	],
	"65387": [
		"default",
		"./account/change-password/token",
		66571
	],
	"78414": [
		"default",
		"./signup/submitpayment/mosaic-edit",
		66571
	],
	"79819": [
		"default",
		"./tv",
		66571
	],
	"93065": [
		"default",
		"./signup",
		66571
	],
	"93278": [
		"default",
		"./tv/select",
		66571
	],
	"96170": [
		"default",
		"./activate",
		66571
	],
	"97882": [
		"default",
		"./mosaic-root",
		66571
	],
	"98832": [
		"default",
		"./check-email",
		66571
	],
	"99091": [
		"default",
		"./signin",
		66571
	]
};
var idToRemoteMap = {
	"1403": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"6940": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"11097": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"17182": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"19421": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"20405": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"28850": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"42514": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"42932": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"57531": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"64523": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"65387": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"78414": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"79819": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"93065": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"93278": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"96170": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"97882": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"98832": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	],
	"99091": [
		{
			"externalType": "script",
			"name": "web_mf_signup",
			"externalModuleId": 66571
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}